import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../../config";
import ReactQuill from "react-quill"; // ReactQuill ইম্পোর্ট
import "react-quill/dist/quill.snow.css"; // Quill এর স্টাইল ইম্পোর্ট


const apiUrl = config.apiUrl;

const CreateBonus = ({ onBonusCreated }) => {
  const [formData, setFormData] = useState({
    slug: "",
    headline: "",
    offer: ""
  });

  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      offer: value || "", // খালি ভ্যালুর জন্য "" সেট করুন
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await axios.post(`${apiUrl}/bonuses`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (onBonusCreated) {
        onBonusCreated();
      }
      alert("Bonus created successfully!");
      // Reset form after successful submission
      setFormData({
        slug: "",
        headline: "",
        offer: ""
      });
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "An error occurred while creating the bonus.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Bonus</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Slug (URL identifier):</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Enter unique slug"
          />
        </div>

        <div>
          <label className="block mb-1">Headline:</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Enter bonus headline"
          />
        </div>

        <div>
          <label className="block mb-1">Offer:</label>

          <ReactQuill
            value={formData.offer || ""} // Ensure Quill gets a valid string
            onChange={handleQuillChange}
            className="border w-full p-2"
          />

        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-2 px-4 bg-green-500 text-white rounded hover:bg-green-600 disabled:bg-gray-400"
        >
          {isSubmitting ? "Creating..." : "Create Bonus"}
        </button>
      </form>
    </div>
  );
};

export default CreateBonus;